//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DishSelectionNoCategories from "./DishSelectionNoCategories";
export default {
  name: 'MenuInsightMajorGroup',
  components: {
    'dish-selection-no-categories': DishSelectionNoCategories
  },
  props: {
    activeCategory: Object,
    activeSubcategory: Object,
    allProductsAsInlineDishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categoriesLoading: Boolean,
    subcategoriesLoading: Boolean,
    productsLoading: Boolean,
    question: {
      type: Object,
      required: true
    },
    response: {
      type: Array,
      required: true
    },
    searchResults: Array,
    searchResultsLoading: Boolean
  }
};